module.exports = __webpack_public_path__ + "static/media/15_blanco.bc9723f9.svg";